// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const _404_TITLE = "Ups, tato str\u00e1nka neexistuje";
